import React from 'react';

var ActivateButton = React.createClass({
	getInitialState: function(){
		return {isClicked: false,
				"style": {},
				"activeClass": "",
				"activeName": ""};
	},
	activateClick: function(){
		// this.props.makeActive(this.props.slug);
		this.setState({isClicked: true});
		// if (this.props.value.user !== localStorage.getItem ('currentAccountSlug')) {
       		var fullyQualifiedName =  this.props.value["name"];
       		this.props.makeActive(fullyQualifiedName);
     	// } else {
       		// this.props.makeActive(this.props.value["slug"]);
     	// }
			 // for waiting after click on activate
			this.setState({style: {"background" : "#0072BC"}});
			this.setState({activeClass: "fa fa-spinner fa-pulse fa-lg fa-fw"});
			this.setState({activeName: "Waiting"});
			this.setState({isClicked: false});

	},
	activeClick: function(){
		alert(this.props.value["name"].split("/")[1].toLowerCase() + " is already active");
	},
	componentDidMount: function(){
		if(localStorage.getItem("active_theme") ===  this.props.account + "/" +  this.props.slug){
			this.setState({style: {"background": "#34b272"}});
			this.setState({activeClass: "fa fa-check-circle"});
			this.setState({activeName: "Active"});
		} else {
			this.setState({style: {"background" : "#0072BC"}});
			this.setState({activeClass: "fa  fa-arrow-circle-up"});
			this.setState({activeName: "Activate"});
		}
	},
	componentWillReceiveProps: function(nextProps){
		if(localStorage.getItem("active_theme") === this.props.account + "/" +  this.props.slug){
			// if(Object.keys(nextProps.value).length > 0 && nextProps.active == nextProps.value["name"].split("/")[0] + "/" + nextProps.value["name"].split("/")[1]){
			// if(localStorage.getItem("active_theme") === this.props.account + "/" +  this.props.slug){
				this.setState({style: {"background": "#34b272"}});
				this.setState({activeClass: "fa fa-check-circle"});
				this.setState({activeName: "Active"});
			} else{
				this.setState({style: {"background" : "#0072BC"}});
				this.setState({activeClass: "fa  fa-arrow-circle-up"});
				this.setState({activeName: "Activate"});
			}
		// }
	},
	render: function(){
		// var style, activeClass, activeName;
		// if(Object.keys(this.props.value).length > 0 && this.props.active == this.props.value["name"].split("/")[0] + "/" + this.props.value["name"].split("/")[1]){
		// // if(localStorage.getItem("active_theme") === this.props.account + "/" +  this.props.slug){
		// 	style = {"background": "#34b272"};
		// 	activeClass = "fa fa-check-circle";
		// 	activeName = "Active";
		// } else if(this.state.isClicked){  // for waiting after click on activate
		// 	style = {"background" : "#0072BC"}
		// 	activeClass = "fa fa-spinner fa-pulse fa-lg fa-fw";
		// 	activeName = "Waiting";
		// 	this.state.isClicked = false;
		// } else{
		// 	style = {"background" : "#0072BC"}
		// 	activeClass = "fa  fa-arrow-circle-up";
		// 	activeName = "Activate";
		// }
		return(
			<li className="animate_btn">
				<a href="javascript:void(0)" style = {this.state.style} onClick = {this.state.activeName === "Activate" ? this.activateClick: this.activeClick}>
					<i className={this.state.activeClass}></i> {this.state.activeName}
				</a>
			</li>
		);
	}
});

export {ActivateButton};



/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/ActivateButton.jsx
 **/